const CartComponent = function($wire) {
    return {
        qrLoaded : false,
        loading : false,
        open :false,
        timeout : null,
        openCart: function () {
            this.open = true;
        },
        closeCart: function () {
            this.open = false;
        },
        reset : function() {
            this.name = '';
            this.number = '';
            this.expires = '';
            this.cvv = '';
            this.birthdate = '';
            this.document = '';
        },
        placeOrder : function() {
            const priceEl = document.getElementById('price-values');

            if (!this.elementIsVisible(priceEl)) {
                this.scrollToElement(priceEl);
                return false;
            }

            this.loading = true;
            
            const deliveryAddress = localStorage.getItem('deliveryAddress') ? JSON.parse(localStorage.getItem('deliveryAddress')) : null;
            this.$wire.call('createOrder', deliveryAddress);
        },
        handleCloseEvent : function (event) {
            if (this.open) {
                this.closeCart();
            }
        },
        paymentStatusEvent : function ($event) {
            clearTimeout(this.timeout);
            this.loading = false;
            if ($event.detail) {
                this.stopLoading()
                const that = this;
                this.timeout = setTimeout(function() {
                    that.$wire.call('checkPaymentStatus', !that.qrLoaded);
                    that.stopLoading();
                }, $event.detail);
            }
        },
        loadQrCodeEvent : function ($event) {
            let qrcodeContainer = document.getElementById('qrcode');
            let qrcodeContainerM = document.getElementById('qrcode_m');
            if (qrcodeContainer) {
                new QRious({
                    element: qrcodeContainer,
                    value: $event.detail,
                    size : 512
                });
                this.qrLoaded = true;
                qrcodeContainer.style.maxWidth = '100%';
            }

            if (qrcodeContainerM) {
                new QRious({
                    element: qrcodeContainerM,
                    value: $event.detail,
                    size : 512
                });
                this.qrLoaded = true;
                qrcodeContainerM.style.maxWidth = '100%';
            }
        },
        stopLoading: function() {
            this.loading = false
        },
        elementIsVisible : function (el)
        {
            if (!el) {
                return  false;
            }

            const rect = el.getBoundingClientRect();
            return (
                rect.top >= 0 &&
                rect.left >= 0 &&
                rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
                rect.right <= (window.innerWidth || document.documentElement.clientWidth)
            );
        },
        scrollToElement : function(el, message = null, timeout = 4000) {
            if (el) {
                el.scrollIntoView({behavior: 'smooth'});
                el.classList.add('animate-pulse');

                setTimeout(function() {
                    el.classList.remove('animate-pulse');
                }, timeout);

                if (message) {
                    this.$dispatch('open-notification', message);
                }
            }
        }
    }
}
export default CartComponent